import { ReactElement } from 'react';
import { GetWebFunctionResponse } from '@localstack/types';
import { getSchema } from '@localstack/services';

import { MagicDetails } from '../../magic/MagicDetails';

export interface LambdaWebFunctionDetailsProps {
  data?: Optional<Partial<GetWebFunctionResponse>>;
}

export const LambdaWebFunctionDetails = ({ data }: LambdaWebFunctionDetailsProps): ReactElement => (
  <MagicDetails data={data} schema={getSchema('LambdaWeb')} entry="GetWebFunctionResponse" title="Web Function" />
);
